export const MQ_MEDIUM_UP = 'min-width: 44rem'
export const MQ_LARGE_UP = 'min-width: 64rem'

export const COL_GREEN = '#95b879'
